import { createContext, useContext, useRef } from 'react';
import { createStore as createVanillaStore, useStore as useZustandStore } from 'zustand';
export function createTasksDrawerStore() {
    return createVanillaStore((set)=>({
            isDrawerOpen: false,
            isTasksDrawerAvailable: false,
            awaitedJobs: new Map(),
            isAwaitingBulkCreateJob: false,
            openDrawer: ()=>set({
                    isDrawerOpen: true
                }),
            closeDrawer: ()=>set({
                    isDrawerOpen: false,
                    isAwaitingBulkCreateJob: false
                }),
            toggle: ()=>set((s)=>({
                        isDrawerOpen: !s.isDrawerOpen
                    })),
            setTasksDrawerAvailable: (available)=>set({
                    isTasksDrawerAvailable: available
                }),
            awaitBulkCreateJob: ()=>set({
                    isAwaitingBulkCreateJob: true
                }),
            registerAwaitedJob: (job)=>set((s)=>{
                    const awaitedJobs = new Map(s.awaitedJobs);
                    awaitedJobs.set(job.jobId, job);
                    return {
                        awaitedJobs
                    };
                }),
            dropAwaitedJob: (jobId)=>set((s)=>{
                    if (!s.awaitedJobs.has(jobId)) return s;
                    const awaitedJobs = new Map(s.awaitedJobs);
                    awaitedJobs.delete(jobId);
                    return {
                        awaitedJobs
                    };
                })
        }));
}
export const TasksDrawerStoreContext = createContext(null);
export function useTasksDrawerStoreApi() {
    const contextStore = useContext(TasksDrawerStoreContext);
    const fallbackRef = useRef(null);
    if (contextStore != null) return contextStore;
    if (fallbackRef.current == null) fallbackRef.current = createTasksDrawerStore();
    return fallbackRef.current;
}
export function useTasksDrawer() {
    const store = useTasksDrawerStoreApi();
    const isDrawerOpen = useZustandStore(store, (s)=>s.isDrawerOpen);
    const isAwaitingBulkCreateJob = useZustandStore(store, (s)=>s.isAwaitingBulkCreateJob);
    const awaitBulkCreateJob = useZustandStore(store, (s)=>s.awaitBulkCreateJob);
    const isTasksDrawerAvailable = useZustandStore(store, (s)=>s.isTasksDrawerAvailable);
    const openDrawer = useZustandStore(store, (s)=>s.openDrawer);
    const closeDrawer = useZustandStore(store, (s)=>s.closeDrawer);
    const toggle = useZustandStore(store, (s)=>s.toggle);
    const setTasksDrawerAvailable = useZustandStore(store, (s)=>s.setTasksDrawerAvailable);
    return {
        isDrawerOpen,
        isAwaitingBulkCreateJob,
        isTasksDrawerAvailable,
        awaitBulkCreateJob,
        openDrawer,
        closeDrawer,
        toggle,
        setTasksDrawerAvailable
    };
}
